import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { UseQueryOptions } from '@tanstack/react-query/src/types';

import CategoryApi from '../../../../lib/api/category/CategoryApi';
import { CATEGORY } from '../../../../constants/queryKeys';
import { ICategoryDetailResponse } from '../types';

const useCategoryDetail = (options: UseQueryOptions<ICategoryDetailResponse>) => {
  const { id } = useParams<{ id: string }>();

  return useQuery<ICategoryDetailResponse>([...CATEGORY.DETAIL, id], () => CategoryApi.getCategoryDetail(Number(id)), {
    ...options,
  });
};

export default useCategoryDetail;
